exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pad-5 {\n\tpadding: 5px;\n}\n.icon-user {\n\tborder: 1px solid #afabab;\n\tbackground: #afabab;\n\tpadding: 5px;\n\tborder-radius: 4px;\n\tmargin-right: 7px;\n\twidth: 38px;\n}\n.add-company:hover{\n\tcolor:gray;\n}\n", ""]);

// exports
